import type { APIClientListResponse, ApiClient } from '../types/apiclients';
import { VL_API_BASE_URL } from '../constants/backendUrls';
import { APIClient } from './apiClient';

const baseUrl = `${VL_API_BASE_URL}/api-clients`;

export async function loadAPIClients () {
    return await APIClient<APIClientListResponse>(`${baseUrl}`);
}

export async function getAPIClientById (apiClientId: string) {
    return await APIClient<ApiClient>(`${baseUrl}/${apiClientId}`);
}

// TODO
export async function saveAPIClient (data: Partial<ApiClient>) {
    return await APIClient<ApiClient>(`${baseUrl}`, { method: 'POST', body: JSON.stringify(data) });
}

// TODO
export async function updateAPIClient (data: Partial<ApiClient>) {
    return await APIClient<ApiClient>(`${baseUrl}`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deleteAPIClient (apiClientId: string) {
    return await APIClient(`${baseUrl}/${apiClientId}`, { method: 'DELETE' });
}

export async function searchSystemApiClient (apiClientName: string) {
    const result = await APIClient<APIClientListResponse>(`${baseUrl}?search=apiClientName=${encodeURIComponent(apiClientName)}`);
    return result?.items[0];
}
